import React, {useContext, useEffect} from "react";
import '../ClientInvoice/ClientInvoice.css'
import parse from "html-react-parser";
import {RecordsManagementContext,ViewMangementContext} from "../StatesMangement/InitialiseContext";
import PrintInvoice from "../CommonComponents/PrintInvoiceCommonButton";
import BackToEstimate from "../ClientInvoice/BackToEstimate";

// used to show the terms and conditions of the company when Digital Invoice is present of the estimate.
export default () => {
    let Record = useContext(RecordsManagementContext)
    let PageView = useContext(ViewMangementContext)

const iv1Details = Record.IV1_PageDetails || {}
const iv2Details = Record.IV2_PageDetails || {}
const iv3Details = Record.IV3_PageDetails || {}

const hasInvoiceData = (details) => {
    if (!details) return false
    const hasTerms = Array.isArray(details.CompanyTermsAndConditions) && details.CompanyTermsAndConditions.length > 0
    const hasCompanyOrDate = Boolean(details.CurrentCompany || details.ServiceDate)
    const hasBranchInfo = details.CompanyBranchAndEstimateInfo && Object.keys(details.CompanyBranchAndEstimateInfo).length > 0
    return hasTerms || hasCompanyOrDate || hasBranchInfo
}

const inferredInvoiceType = PageView.InvoiceType ||
    (hasInvoiceData(iv3Details) ? 'INVOICE_3' : hasInvoiceData(iv2Details) ? 'INVOICE_2' : 'INVOICE_1')

const isInvoice1 = inferredInvoiceType === 'INVOICE_1'
const isInvoice3 = inferredInvoiceType === 'INVOICE_3'
let pageDetails = isInvoice1 ? iv1Details : isInvoice3 ? iv3Details : iv2Details
    let backgroundColor1 = isInvoice1 ?
        ((pageDetails.BackgroundColor && pageDetails.BackgroundColor.BgColor1) || '#172b4d') :
        ((pageDetails.CompanyBranchAndEstimateInfo && pageDetails.CompanyBranchAndEstimateInfo.BgColor1) || '#172b4d')
    let backgroundColor2 = isInvoice1 ?
        ((pageDetails.BackgroundColor && pageDetails.BackgroundColor.BgColor2) || '#1d4d6e') :
        ((pageDetails.CompanyBranchAndEstimateInfo && pageDetails.CompanyBranchAndEstimateInfo.BgColor2) || '#1d4d6e')
    let Conditions = pageDetails.CompanyTermsAndConditions || []
    const companyName = (pageDetails.CurrentCompany ||
        (pageDetails.CompanyBranchAndEstimateInfo && pageDetails.CompanyBranchAndEstimateInfo.CBName) ||
        '').toString().trim()

    const normalizeTermsContent = (content) => {
        if (!content) return ''
        if (!companyName) return content

        return content
            .replace(/%current_company%/gi, companyName)
            .replace(/%company_name%/gi, companyName)
            .replace(/%company%/gi, companyName)
            .replace(/###/g, companyName)
            .replace(/\bMoving companies\b/gi, companyName)
            .replace(/\bMoving company\b/gi, companyName)
    }

    const ShowFrontPage = () => { // set the page view (either Invoice 1, 2 or 3)
        if (inferredInvoiceType === 'INVOICE_3') {
            PageView.Set('INVOICE_3')
        } else if (inferredInvoiceType === 'INVOICE_2') {
            PageView.Set('INVOICE_2')
        } else {
            PageView.Set('INVOICE_1')
        }
    }
    useEffect(() => {//when scroll the page down the page's header still show on the page .
        window.addEventListener('scroll', stickyHead);
        return () => {
            window.removeEventListener('scroll', stickyHead);
        };
    });
    const stickyHead = (e) => {//to make the page's header sticky.
        const header = document.querySelector('.sticky-head');
        if (!header) return;
        const scrollTop = window.scrollY;
        scrollTop  > 0 ? header.setAttribute('style', 'top: 0; border-bottom: #17a2b8 2px solid !important;margin-left:-23px;')  : header.setAttribute('style', 'top: 0; border-bottom: 0px; margin-left:-23px');
    };
    return (
        <div style={{backgroundColor: "#172b4d", backgroundImage:  `linear-gradient(45deg, ${backgroundColor1} 15%, ${backgroundColor2} 85%)`}}>
            <div className='width-wrapper px-4'>
                <table className="table">
                    <thead className="sticky-head" style={{ top: 0,marginLeft: "-23px"}}>
                    <tr>
                        <th className="th-main-bost">
                            <table className="table">
                                <tbody>
                                <tr>
                                    <td className="td-main-bost">
                                        <BackToEstimate/>
                                    </td>
                                    <td className="td-main-bost" style={{textAlign: "center"}}>
                                        This Estimate is Booked For - {pageDetails.ServiceDate}
                                    </td>
                                    <td className="td-main-bost" style={{float: "right",paddingLeft:"42px"}}>
                                        <PrintInvoice/>&nbsp;&nbsp;
                                        <button  className='btn btn-dark btn-sm' onClick={()=> ShowFrontPage()}>
                                            <b>SHOW FRONT PAGE</b></button>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr>
                        <td className="td-main-bost set-pid" style={{textAlign: "center"}} colSpan={4}>
                            <h6> {companyName} TERMS AND CONDITIONS </h6>
                        </td>
                    </tr>
                    <tr>
                        <td className="td-main-bost terms-text" colSpan={4}>
                            {Conditions.map((text,i) => {
                                return (
                                    <React.Fragment key={`tc_${i}`}>
                                        <h6><u>{i+1}. {text.heading}</u></h6>
                                        <p style={{textAlign: "justify"}}>{parse(normalizeTermsContent(text.content))}</p><br/>
                                    </React.Fragment>
                                )
                            })
                            }
                        </td>
                    </tr>
                    </tbody>
                </table>
            </div>
        </div>
    )
}
